// extracted by mini-css-extract-plugin
export default {"root":"BackToTop-module__[local]___tTp9w","bounce-in":"BackToTop-module__[local]___2hExn"};